import * as React from 'react'

import type { Moment } from 'moment'
import { formatDateTime } from 'app/common/dateHelper'
import { TmsDataModel } from 'app/models/tmsDataModel'
import { getTmsRouteTypeColor } from 'app/services/tms/tmsRouteTypeColorResolver'
import { getTmsRouteTypeName } from 'app/services/tms/tmsRouteTypeNameResolver'
import { TmsRouteType } from 'app/constants/tmsRouteType'
import { CountryModel } from 'app/models/timesheet/countryModel'
import { TooltipLayout } from './ToolTipLayout'

type TmsDataItemTooltipProps = {
  tmsData: TmsDataModel
  translate: (text) => any
}
type TmsDataItemTooltipState = {}

export class TmsDataItemTooltip extends React.Component<
  TmsDataItemTooltipProps,
  TmsDataItemTooltipState
> {
  constructor(props: TmsDataItemTooltipProps) {
    super(props)
  }

  private buildRowsForTmsData(
    routeType: TmsRouteType,
    docNumber: string,
    transitCountry: CountryModel,
    loadingDate: Moment,
    unloadingDate: Moment,
    loadingCountry: CountryModel,
    unloadingCountry: CountryModel,
  ) {
    const isTransitOrEmpty =
      routeType == TmsRouteType.Transit ||
      routeType == TmsRouteType.PolishTransit ||
      routeType == TmsRouteType.Empty ||
      routeType == TmsRouteType.CabotageEmpty ||
      routeType == TmsRouteType.CrossTradeWrongEmpty ||
      routeType == TmsRouteType.CrossTradeBilateralEmpty

    const rows = []

    if (!isTransitOrEmpty) {
      rows.push({
        title: this.props.translate(
          'newDelegation.delegationMarkerPopup.docNumber',
        ),
        value: docNumber,
      })
    }

    rows.push({
      title: this.props.translate(
        'newDelegation.delegationMarkerPopup.routeType',
      ),
      value: this.props.translate(getTmsRouteTypeName(routeType)),
    })

    if (routeType == TmsRouteType.Transit) {
      rows.push({
        title: this.props.translate(
          'newDelegation.delegationMarkerPopup.transitCountry',
        ),
        value: transitCountry?.name || '-',
      })
    }

    if (isTransitOrEmpty) {
      rows.push({
        title: this.props.translate(
          'newDelegation.delegationMarkerPopup.dateFrom',
        ),
        value: formatDateTime(loadingDate),
      })
      rows.push({
        title: this.props.translate(
          'newDelegation.delegationMarkerPopup.dateTo',
        ),
        value: formatDateTime(unloadingDate),
      })
    } else {
      rows.push({
        title: this.props.translate(
          'newDelegation.delegationMarkerPopup.loading',
        ),
        value: formatDateTime(loadingDate),
      })
      if (loadingCountry) {
        rows.push({
          title: this.props.translate(
            'newDelegation.delegationMarkerPopup.loadingCountry',
          ),
          value: loadingCountry.name,
        })
      }
      rows.push({
        title: this.props.translate(
          'newDelegation.delegationMarkerPopup.unloading',
        ),
        value: formatDateTime(unloadingDate),
      })
      if (unloadingCountry) {
        rows.push({
          title: this.props.translate(
            'newDelegation.delegationMarkerPopup.unloadingCountry',
          ),
          value: unloadingCountry.name,
        })
      }
    }

    return rows
  }

  render() {
    const {
      loadingDate,
      unloadingDate,
      routeType,
      docNumber,
      loadingCountry,
      unloadingCountry,
      transitCountry,
    } = this.props.tmsData

    const rows = this.buildRowsForTmsData(
      routeType,
      docNumber,
      transitCountry,
      loadingDate,
      unloadingDate,
      loadingCountry,
      unloadingCountry,
    )

    // Jeśli są powiązane TMS, pokaż je jako osobne tooltips
    if (
      this.props.tmsData.associatedTms &&
      this.props.tmsData.associatedTms.length > 0
    ) {
      return (
        <div className="tw-flex tw-flex-col tw-gap-2">
          <TooltipLayout
            headerColor={getTmsRouteTypeColor(routeType)}
            headerTitle={this.props
              .translate('eventName.tmsData')
              .toString()
              }
            rows={rows}
          />
          {this.props.tmsData.associatedTms.map((at, index) => {
            const associatedRows = this.buildRowsForTmsData(
              at.routeType,
              at.docNumber,
              at.transitCountry,
              at.loadingDate,
              at.unloadingDate,
              at.loadingCountry,
              at.unloadingCountry,
            )
            return (
              <TooltipLayout
                key={index}
                headerColor={getTmsRouteTypeColor(at.routeType)}
                headerTitle={this.props
                  .translate('eventName.tmsData')
                  .toString()
                 }
                rows={associatedRows}
              />
            )
          })}
        </div>
      )
    }

    return (
      <TooltipLayout
        headerColor={getTmsRouteTypeColor(routeType)}
        headerTitle={this.props
          .translate('eventName.tmsData')
          .toString()
          }
        rows={rows}
      />
    )
  }
}
